import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20">
    <path d="M20.5 20H3c-1.7 0-3-1.3-3-3V.5C0 .2.2 0 .5 0h7c.3 0 .5.2.5.5V2h12.5c.3 0 .5.2.5.5V4h2.5c.3 0 .5.2.5.5v12c0 1.9-1.6 3.5-3.5 3.5zM5.2 19h15.3c1.4 0 2.5-1.1 2.5-2.5V5H6v12c0 .8-.3 1.5-.8 2zM1 1v16c0 1.1.9 2 2 2s2-.9 2-2V4.5c0-.3.2-.5.5-.5H20V3H7.5c-.3 0-.5-.2-.5-.5V1H1z" />
    <path d="M19.5 16h-10c-.2 0-.4-.1-.5-.3 0-.2 0-.4.1-.5l2.5-3c.1-.2.4-.2.6-.1l1.7.8 2.7-3.2c.1-.1.3-.2.5-.2s.3.1.4.3l2.5 5.5c.1.2.1.3 0 .5-.2.1-.3.2-.5.2zm-8.9-1h8.2l-1.9-4.1-2.5 2.9c-.2.2-.4.2-.6.1l-1.6-.8-1.6 1.9zM11.5 11c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm0-3c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1z" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/nav-media.es6.js